// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OIV9","col":"styles_col__2id7n","actions":"styles_actions__3Uks-","conflict":"styles_conflict__17XSy"};